import {
  OrganizationProfile,
  OrganizationSwitcher,
  useAuth,
  useUser,
} from "@clerk/clerk-react";
import { Pressable, SafeAreaView, View } from "react-native";
import StyledText from "../components/common/ui/styled-text";
import { useRouter } from "expo-router";
import Access from "../components/feature/access/access";
import { ArrowLeft, Key } from "lucide-react-native";
import { useViewport } from "../hooks/useViewport";

const OrganizationPage = () => {
  const { user } = useUser();
  const { isMobile } = useViewport();
  const isMultiOrg =
    user?.organizationMemberships?.length &&
    user?.organizationMemberships?.length > 1;
  const { orgRole } = useAuth();
  const isOrgAdmin = orgRole === "org:admin";

  const router = useRouter();

  const handleBackPress = () => {
    router.back();
  };

  return (
    <SafeAreaView className="flex-1 bg-white">
      <View className="flex-row items-center justify-between p-4 border-b border-gray-200 h-[64px]">
        <Pressable onPress={handleBackPress} className="flex-row items-center">
          <ArrowLeft size={20} />
          <StyledText className="ml-2 text-lg font-semibold">
            Organization
          </StyledText>
        </Pressable>
        {isMultiOrg && !isMobile && (
          <View className="flex-1 w-full justify-end items-center flex-row gap-4">
            <View className="border border-border p-1 rounded-lg shadow bg-white">
              <OrganizationSwitcher hidePersonal />
            </View>
          </View>
        )}
      </View>

      <View className="flex-1 items-center overflow-y-auto p-4 sm:pl-20 lg:pl-4">
        <OrganizationProfile>
          {isOrgAdmin && (
            <OrganizationSwitcher.OrganizationProfilePage
              label="Access"
              url="access"
              labelIcon={<Key size={16} />}
            >
              <Access />
            </OrganizationSwitcher.OrganizationProfilePage>
          )}
        </OrganizationProfile>
      </View>
    </SafeAreaView>
  );
};

export default OrganizationPage;
